import { useUiStore } from '@/common/uiStore.ts';
import useAppStore from '../../../store/rootStore.ts';

// `customSlippagePercent === null` means "follow the API default" — do NOT
// snapshot the current `market.orderMaxImpactP` into the store when the user
// picks that option, or they'll be stuck on a stale default when the backend
// updates its value.
export function resolveUserSlippagePercent(): number | undefined {
  const enabled = useAppStore.getState().config?.features.customSlippageEnabled;
  if (!enabled) return undefined;
  const value = useUiStore.getState().customSlippagePercent;
  return value ?? undefined;
}
